import React from "react";
import {
  TableHead,
  TableRow,
  TableCell,
  Checkbox,
  Typography,
  Box,
} from "@mui/material";
import OrderArrow from "../../../components/VectorIcons/OrderArrow";
import { addendumCellSx } from "./releasedAddendum.utils";

const headerLabelSx = {
  fontFamily: '"Globotipo Text Bold"',
  letterSpacing: 0.8,
  color: "#43444D",
};

const ReleasedAddendumTableHeader = ({
  isChapter,
  allSelected,
  hasSelectableItems,
  onToggleAll,
  orderBy,
  setOrderBy,
  showOrderArrow,
  setShowOrderArrow,
}) => {
  const TableHeadCell = ({ children, orderA, orderB }) => (
    <Box
      sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}
      onClick={() => setOrderBy(orderBy === orderA ? orderB : orderA)}
    >
      <span
        style={{
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          position: "relative",
          userSelect: "none",
        }}
      >
        {children}
        {showOrderArrow && (
          <OrderArrow
            upColor={orderBy === orderA ? "#666666" : "#CCCCCC"}
            downColor={orderBy === orderB ? "#666666" : "#CCCCCC"}
            style={{ position: "absolute", right: "100%", marginRight: "3px" }}
          />
        )}
      </span>
    </Box>
  );

  return (
    <TableHead
      sx={{ backgroundColor: "#e0e2ff", py: 0 }}
      onMouseEnter={() => setShowOrderArrow(true)}
      onMouseLeave={() => setShowOrderArrow(false)}
    >
      <TableRow>
        <TableCell sx={{ ...addendumCellSx, width: "32px" }}>
          {hasSelectableItems && (
            <Checkbox
              size="small"
              checked={allSelected}
              onChange={onToggleAll}
              sx={{ "&.Mui-checked": { color: "#0098CD" } }}
            />
          )}
        </TableCell>

        <TableCell sx={{ ...addendumCellSx, px: 0, maxWidth: "300px" }}>
          <Typography variant="caption" sx={headerLabelSx}>
            ARQUIVO
          </Typography>
        </TableCell>

        <TableCell align="right" sx={addendumCellSx}>
          <TableHeadCell orderA="associations-asc" orderB="associations-desc">
            <Typography variant="caption" sx={headerLabelSx}>
              {isChapter
                ? "ASSOCIAÇÕES COM CAPÍTULOS"
                : "ASSOCIAÇÕES COM EPISÓDIOS"}
            </Typography>
          </TableHeadCell>
        </TableCell>

        <TableCell align="right" sx={{ ...addendumCellSx, pl: 4 }}>
          <TableHeadCell orderA="receivedAt-asc" orderB="receivedAt-desc">
            <Typography variant="caption" sx={headerLabelSx}>
              LIBERADO EM
            </Typography>
          </TableHeadCell>
        </TableCell>

        <TableCell sx={{ ...addendumCellSx, width: 110 }} />
      </TableRow>
    </TableHead>
  );
};

export default ReleasedAddendumTableHeader;
